import type { SearchTermRuleId } from "./types";

export type { SearchTermRuleId };

/**
 * Search term validation predicates, keyed by the id a config names. Each
 * predicate returns true when the term SATISFIES the rule, so a false result
 * is what raises the config's message.
 *
 * The predicates stay in code and a config supplies only the id and the
 * message. A config that shipped its own regular expression would be a
 * pattern-injection surface, remotely reachable once the config comes from a
 * backend, where a catastrophically backtracking pattern stalls the main
 * thread.
 *
 * Typing this as a Record over the id union means an id cannot be added to
 * types.ts without a predicate landing here.
 */
export const SEARCH_TERM_RULES: Record<SearchTermRuleId, (term: string) => boolean> = {
  /**
   * Digits only, at least one, and no hyphen. Deliberately stricter than the
   * rule it replaces, which permitted a hyphen and so accepted `123-456` as an
   * employee ID.
   */
  digitsOnly: (term) => /^[0-9]+$/.test(term),
};
